var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { Component, Inject, Prop } from 'vue-property-decorator';
import { DEFAULT_INLINE_STYLE_PROPS, INJECT_UICORE_BUS, INJECT_UICORE_DESIGNER } from "../../../../../../lib/utils/consts";
import CSSEditor from "../../../../../../lib/comps/CSSEditor";
import { filter, get } from "lodash-es";
import * as styles from "./index.module.css";
/** 化简可能出现的多余的加减样式 */
export function simplifyInlineStyleProps(items) {
  const addInline = new Set();
  const removeInline = new Set();
  // 消消乐
  Array.isArray(items) && items.forEach(s => {
    addInline[s[0] === '+' ? 'add' : 'delete'](s.slice(1));
    removeInline[s[0] === '-' ? 'add' : 'delete'](s.slice(1));
  });
  return [...Array.from(addInline).map(item => `+${item}`), ...Array.from(removeInline).map(item => `-${item}`)];
}
const INLINE_SEQUENCE = ['-', '+', '[]'];
let PanelStateCssEditor = class PanelStateCssEditor extends Vue {
  constructor() {
    super(...arguments);
    this.helperUrl = '';
  }
  get stylePanelState() {
    return this.designer.stylePanelState;
  }
  renderInlineOptions() {
    const h = this.$createElement;
    const {
      stylePanelState
    } = this;
    // 只有 组件本体 + static选择器才启用inline选择
    if (!stylePanelState.isRootSelector) return;
    const defaultInlineProps = simplifyInlineStyleProps([...DEFAULT_INLINE_STYLE_PROPS, ...get(this.designer.activeCompMeta, 'inlineStyleProps', [])]);
    return h("div", {
      "style": "display:none;"
    }, [Object.entries(stylePanelState.styles).map(([styleProp]) => {
      const inlineMode = stylePanelState.inlineStyleProps.find(item => item.slice(1) === styleProp) || '';
      const mode = INLINE_SEQUENCE.find(item => inlineMode.includes(item)) || '[]';
      const displayByMode = () => {
        if (mode !== '[]') return mode;
        const overrideByDefault = defaultInlineProps.find(item => item.slice(1) === styleProp);
        if (!overrideByDefault) return '[-]';
        return overrideByDefault[0] === '+' ? '[+]' : '[-]';
      };
      return h("div", [h("span", {
        "class": styles.inlineSwitchSpan,
        "ref": `checkbox-${styleProp}`,
        "on": {
          "click": () => {
            const index = INLINE_SEQUENCE.indexOf(mode);
            const newMode = INLINE_SEQUENCE[(index + 1) % 3];
            let inlineStyles = filter(stylePanelState.inlineStyleProps, item => item.slice(1) !== styleProp);
            if (newMode !== '[]') {
              inlineStyles = [...inlineStyles, newMode + styleProp];
            }
            inlineStyles = simplifyInlineStyleProps(inlineStyles);
            stylePanelState.inlineStyleProps = inlineStyles;
          }
        }
      }, [displayByMode()])]);
    })]);
  }
  created() {
    const HELP_URL_KEY = 'cssInlineAdvanced';
    this.helperUrl = this.uc.config.docEnable ? this.uc.config.docLink[HELP_URL_KEY] : '';
  }
  renderInlineHints() {
    const h = this.$createElement;
    return h("span", [!!this.helperUrl ? h("a", {
      "attrs": {
        "target": "_blank",
        "href": this.helperUrl
      }
    }, ["\u9AD8\u7EA7\u529F\u80FD\u6587\u6863:\u5185\u8054\u6837\u5F0F\u8BBE\u7F6E"]) : null]);
  }
  get enableInlineSetting() {
    return this.stylePanelState.isRootSelector && this.enableAdvancedInlineSetting;
  }
  handleChange(value) {
    if (this.readonly) return;
    this.stylePanelState.styles = value;
  }
  render() {
    var _this$value;
    const h = arguments[0];
    const {
      stylePanelState
    } = this;
    return h("div", [this.enableInlineSetting && this.renderInlineHints(), h(CSSEditor, {
      "attrs": {
        "readonly": this.readonly,
        "value": (_this$value = this.value) !== null && _this$value !== void 0 ? _this$value : stylePanelState.styles,
        "getInlineCheckBoxNode": () => this,
        "enableInlineCheckBox": this.enableInlineSetting
      },
      "on": {
        "change": this.handleChange
      }
    }), this.enableInlineSetting && this.renderInlineOptions()]);
  }
};
__decorate([Inject({
  from: INJECT_UICORE_BUS,
  default: null
})], PanelStateCssEditor.prototype, "uc", void 0);
__decorate([Inject({
  from: INJECT_UICORE_DESIGNER
})], PanelStateCssEditor.prototype, "designer", void 0);
__decorate([Prop({
  type: Boolean,
  default: false
})], PanelStateCssEditor.prototype, "enableAdvancedInlineSetting", void 0);
__decorate([Prop({
  type: Boolean,
  default: false
})], PanelStateCssEditor.prototype, "readonly", void 0);
__decorate([Prop({
  type: Object
})], PanelStateCssEditor.prototype, "value", void 0);
PanelStateCssEditor = __decorate([Component({
  name: 'PanelStateCssEditor'
})], PanelStateCssEditor);
export { PanelStateCssEditor };
//# sourceMappingURL=index.js.map
